export default __webpack_public_path__ + "static/media/10.3c81b428.jpg";